module.exports = __webpack_public_path__ + "lounaspaikka-af40f669d98e2f04d849.png";